import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'country-crop-policies',
  templateUrl: './country-crop-policies.component.html',
  styleUrls: ['./country-crop-policies.component.scss']
})
export class CountryCropPoliciesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
